import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Input, Select, Form, Row, Col } from "antd";
import moment from "moment";

import {
  getGatewayIpns,
  downloadRecords,
} from "../../../redux/actions/Gateway";
import PageLimitSwitch from "../../../components/PageLimitSwitch";

import { selectProcessor } from "../../../redux/actions/Common";

import generateQuery, { handleSearch as search } from "../../../util/table";
import DownloadBtns from "../../../components/common/downloadbtns";
import { getProcessors } from "../../../redux/actions/Processors";

const { Option } = Select;
const columns = [
  {
    title: "Created",
    dataIndex: "created_at",
    render: (date) => <span>{moment(date).format("DD/MM/YY h:mm:ss a")}</span>,
    sorter: true,
    search: false,
  },
  {
    title: "Account",
    dataIndex: "account",
    sorter: true,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    sorter: true,
    type: "number",
  },
  {
    title: "Currency",
    dataIndex: "currency",
    sorter: true,
    search: true,
  },
  {
    title: "status",
    dataIndex: "status",
    sorter: true,
    search: true,
  },
  {
    title: "P/R",
    dataIndex: "kitegateway_reference",
    sorter: true,
    width: 200,
  },
  {
    title: "Processor Reference",
    dataIndex: "processor_reference",
    sorter: true,
  },
];

const IPNs = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    data: gatewayIpns,
    pageSize: gatewayIpnsPageSize,
    currentPage: gatewayIpnsCurrentPage,
    totalRecords: gatewayIpnsTotalRecords,
    loading: gatewayIpnsLoading,
  } = useSelector(({ gateway }) => gateway.gateway_ipns);

  const {
    data: processorsData,
    loading: processorsLoading,
    pageSize: processorsPageSize,
    currentPage: processorsCurrentPage,
    totalItems: processorsTotalRecords,
  } = useSelector(({ processors }) => processors.allProcessors);

  const { selectedProcessor } = useSelector(({ common }) => common);
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    const pagination = `page=${processorsCurrentPage}&limit=${processorsPageSize}`;
    dispatch(getProcessors(pagination));
  }, [dispatch, processorsTotalRecords]);

  useEffect(() => {
    if (processorsData.length > 0) {
      dispatch(selectProcessor(processorsData[0].code));
    }
  }, [dispatch]);

  useEffect(() => {
    if (selectedProcessor) {
      const pagination = `page=${gatewayIpnsCurrentPage}&limit=${gatewayIpnsPageSize}`;
      dispatch(getGatewayIpns(pagination));
    }
  }, [dispatch, selectedProcessor]);

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(
      getGatewayIpns(generateQuery(pagination, filters, sorter, searchParams))
    );
  };

  const handleSearch = (searchValue) => {
    const query = search(searchValue, dispatch, getGatewayIpns, columns);
    setSearchParams(query);
  };

  const navigateToView = (record) => ({
    onClick: () => {
      history.push(`/gateway-ipns/${selectedProcessor}/${record._id}`);
    },
  });

  const props = {
    pagination: false,
    onRow: navigateToView,
    onChange: handleOnChange,
    loading: processorsLoading || gatewayIpnsLoading,
    columns,
    dataSource: gatewayIpns,
  };

  const handleChange = (value) => {
    dispatch(selectProcessor(value));
  };

  const handleDownload = (type = null) => {
    let searchParameters = [];
    let filterParams = "";
    if (searchParams) {
      searchParameters = [...searchParams];
      filterParams = `filter={"$or": ${JSON.stringify(
        searchParameters
      )}}&sort={"created_at":-1}&limit=${gatewayIpnsPageSize}&page=${gatewayIpnsCurrentPage}`;
    } else {
      filterParams = `sort={"created_at":-1}&limit=${gatewayIpnsPageSize}&page=${gatewayIpnsCurrentPage}`;
    }

    dispatch(downloadRecords(filterParams, type));
  };

  return (
    <div>
      <div style={{ display: "flex" }}>
        <h2 className="title gx-mb-4" style={{ flexGrow: 2 }}>
          Processor IPNs
        </h2>

        <Form.Item label="" style={{ margin: 0, minWidth: "150px" }}>
          <Select
            allowClear
            showArrow
            placeholder="Select Processor"
            value={selectedProcessor}
            onChange={handleChange}
          >
            {processorsData.length &&
              processorsData.map((processor) => (
                <Option key={processor.code}>{processor.name}</Option>
              ))}
          </Select>
        </Form.Item>
        <DownloadBtns
          handlePdf={() => handleDownload("pdf")}
          handleXcl={() => handleDownload("excel")}
        />
      </div>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search Processor IPNs"
          enterButton
          allowClear
          onSearch={(value) =>
            handleSearch(value, dispatch, getGatewayIpns, columns)
          }
        />
      </div>
      <div className="gx-d-flex justify-content-center">
        <Table className="gx-table-responsive striped-table" {...props} />
      </div>
      <Row className="pagination">
        <Col md={12}>
          <PageLimitSwitch
            resourceType="gateway_ipns"
            limit={gatewayIpnsPageSize}
            limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
            totalRecords={gatewayIpnsTotalRecords}
            currentPage={gatewayIpnsCurrentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default IPNs;
